import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import './style.css';
var ToasterMark = function (props) {
    var ToasterIcon = props.ToasterIcon;
    return (_jsx(_Fragment, { children: _jsx("div", { className: "ellipse", children: _jsx(ToasterIcon, {}) }) }));
};
export default ToasterMark;
